import { render, staticRenderFns } from "./OnlineTrainingGeneral.vue?vue&type=template&id=744310a0"
import script from "./OnlineTrainingGeneral.vue?vue&type=script&lang=js"
export * from "./OnlineTrainingGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports